// extracted by mini-css-extract-plugin
export default {"content":"zoa-z","title":"Aoa-z","subTitle":"Boa-z","banner":"Coa-z","productCardOverride":"Doa-z"};